import axios from 'axios';

export class PatientAccessClient{
  constructor (access) {
    this.access = access
    this.instance = this.instantiateInstance(access.content)
  }


  async sanitizeAccess(attempts=2) {
    // Update "legacy" accesses
    const pryvio = "pryv.io"
    if (!this.access.content.includes(pryvio)) {
      return 
    }
    return this.instance.put(`/events/${this.access.id}`, {
      content: this.access.content.replace(pryvio, "net")
    })
      .then(res => {
        this.instantiateInstance(res.data)
      })
      .catch(e => {
        if (0 < attempts) {
          this.sanitizeAccess(attempts - 1)
        }
        throw(e)
      })
  }

  getAccessInfo(attempts=2) {
    const remainingAttempts = attempts - 1
    return this.instance.get('/access-info')
      .catch(e => {
        if (0 < remainingAttempts){
          return this.getAccessInfo(remainingAttempts)
        }
        throw(e)
      })
  }


  fetchProfileInfo(attempts=2) {
    return this.instance.get("/events/", {
      params: {
        streams: ["profile"],
        fromTime: 0,
        toTime: this.constructor.getFutureUnix()
      },
      paramsSerializer: pryvEncoder
    })
      .catch(e => {
        if (0 < attempts){
          return this.fetchProfileInfo(attempts-1)
        }
        throw(e)
      })
  }
  
  fetchMetaEvents(attempts=2) {
    const remainingAttempts = attempts - 1
    
    const requestBody = [
      {
        method: "events.get",
        params: {
          fromTime: 0,
          toTime: this.constructor.getFutureUnix(),
          streams: process.env.REACT_APP_CERTIFICATION === 'certified' ? {
            any: ['certified'],
            not: ['not-certified'],
          } : [
            'certified',
            'non-certified',
          ],
          types: ['activity/magnes-v2', 'activity/magnes-v1']
        }
      }
    ]
    return this.instance.post("", requestBody)
      .catch(e => {
        if (0 < remainingAttempts){
          return this.fetchMetaEvents(remainingAttempts)
        }
        throw(e)
      })
  }

  getActiveEndpoint() {
    return this.access.content
  }

  getUsername() {
    return this.constructor.parseUsername(this.access.content)
  }


  static getFutureUnix () {
    return ~~(+new Date() / 1000) + 60 * 60 * 24;
  }
  
  static parseUsername(endpoint) {
    return endpoint.split('@')[1].split('.')[0]
  }

  static parseToken(endpoint) {
    return endpoint.split("@")[0].split("//")[1]
  }

  static parseBaseURL(endpoint) {
    return `https://${endpoint.split("@")[1]}`
  }

  instantiateInstance(endpoint) {
    return axios.create({
      baseURL: this.constructor.parseBaseURL(endpoint),
      timeout: 1500,
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Authorization": this.constructor.parseToken(endpoint)
      }
    })
  }

  updateAccess(newAccess) {
    this.access = newAccess
    this.instance = this.instantiateInstance(newAccess.content)
  }
}


// Custom paramsSerializer
const pryvEncoder = (params) => {
  const encodedParams = [];

  for (const [key, value] of Object.entries(params)) {
    if (typeof value === 'object' && value !== null) {
      encodedParams.push(`${key}=${encodeURIComponent(JSON.stringify(value))}`);
    } else {
      encodedParams.push(`${key}=${encodeURIComponent(value)}`);
    }
  }

  return encodedParams.join('&');
};